module.exports = __webpack_public_path__ + "img/icon-gift.eb4b7311.png";